import { render, staticRenderFns } from "./ProblemFeedbackList.vue?vue&type=template&id=733a513f"
import script from "./ProblemFeedbackList.vue?vue&type=script&lang=js"
export * from "./ProblemFeedbackList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports